// removed by extract-text-webpack-plugin
module.exports = {"header":"_10dus","timelabel":"p-FP3","wrapper":"_29VXt","toggleWrapper":"_2Qix7","toggle":"_1CuxO","active":"jmgEi _1CuxO","inactive":"_1JhZj _1CuxO","partyHeader":"_jvNs","delegateCount":"_1MTNY","test":"_2talq","row":"hLJqm"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Results.scss
 ** module id = 109
 ** module chunks = 0
 **/